import { Avatar } from '@mui/material'

type Props = {
  firstName: string
  lastName: string
}

const AvatarComponent = ({ firstName, lastName }: Props) => {
  return (
    <Avatar>
      {firstName.charAt(0).toUpperCase()}
      {lastName.charAt(0).toUpperCase()}
    </Avatar>
  )
}

export default AvatarComponent
